'use strict';

const utils = require('./shared/z-vue-scan.f46feabf.cjs');

const plugin = {
  install: (app, options) => {
    const { enable = utils.isDev() } = options || {};
    if (!enable) {
      return;
    }
    app.mixin({
      mounted() {
        const instance = this;
        if (!instance.__bu) {
          instance.__bu = utils.createOnBeforeUpdateHook(instance, options);
        }
        if (!instance.__bum) {
          instance.__bum = utils.createOnBeforeUnmountHook(instance);
        }
        instance.__vue_scan_injected__ = true;
      },
      beforeUpdate() {
        const instance = this;
        instance.__bu?.();
      },
      beforeDestroy() {
        const instance = this;
        instance.__bum?.();
      }
    });
  }
};

module.exports = plugin;
